var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('ul',{staticClass:"tabs-links"},_vm._l((_vm.tabs),function(tab){return _c('li',{class:{ 'active': tab.isActive }},[_c('a',{attrs:{"href":tab.href},on:{"click":function($event){return _vm.selectTab(tab)}}},[_vm._v(_vm._s(tab.title))])])}),0),_vm._v(" "),_c('div',{staticClass:"tabs-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }